import React, {useEffect} from 'react';

import {useAppContext, useAnalytics} from '../../hooks';

export default function Waitlist() {
  const {currentUser} = useAppContext();
  const {tracker} = useAnalytics();

  useEffect(() => {
    tracker.jobReferralRequestWaitlistView({
      email: currentUser?.email, country: currentUser?.data?.country,
    });
  }, []);

  return (
    <>
      <h1 className="w-full block my-2 md:my-4 text-xl md:text-4xl text-center font-bold text-gray-900">
        You&apos;ve been added to the waitlist
      </h1>

      <span className="block w-full md:w-4/5 mx-auto mb-1 text-sm md:text-base text-center font-medium leading-tight text-gray-600">
        Unfortunately, we&apos;re not able to support job referrals in all parts of the world yet.
        We&apos;ve recorded your interest and will be in touch when this feature is available
        to you.
      </span>
    </>
  );
}
